<div class="wk8-lees" [style.font-size.rem]="fontSize()">
  <div class="container" style="position: relative; display: flex; gap: 0.5em; align-items: center">
    @if (isMetronomeVisible()) {
      <div
        class="metronome"
        style="position: absolute; display: flex; gap: 0.5em; align-items: center; left: 0; translate: calc(-100% - 0.5em) 0"
        @modal
      >
        <!-- @if (index() <= 0) { -->
        <div class="metronome-item activatable" [style.--duration.ms]="timePerKlank()" [class.active]="hasHighlight(-2)"></div>
        <!-- } -->
        <!-- @if (index() <= 1) { -->
        <div class="metronome-item activatable" [style.--duration.ms]="timePerKlank()" [class.active]="hasHighlight(-1)"></div>
        <!-- } -->
      </div>
    }
    <div class="parts" style="display: flex; gap: 0.5em; align-items: center">
      <div style="display: flex; align-items: center">
        @for (part of parts(); track part.id) {
          <wk8-paper-piece
            [paddingLeft]="isCondensed() && $index > 0 ? 'NONE' : 'LARGE'"
            [paddingRight]="isCondensed() && $index < parts().length - 1 ? 'NONE' : 'LARGE'"
          >
            <div
              class="activatable"
              [style.--duration.ms]="timePerKlank()"
              [class.active]="hasHighlight($index)"
              [@klankChange]="part.klank"
            >
              {{ part.klank }}
            </div>
          </wk8-paper-piece>
          <div class="spacer" style="transition: width 0.25s var(--ease-in-back)" [style.width.em]="isCondensed() ? 0 : 0.25"></div>
        }
      </div>
    </div>
  </div>
</div>
